export default {
      id: "about-system-usage",
      viewBox: "0 0 352 268",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#about-system",
      toString: function () {
        return this.url;
      }
    }